import { requestActions } from "./utils";

export const INVITATION_CREATE = requestActions("Invitation/Create");
export const INVITATION_RESEND = requestActions("Invitation/Resend");
